import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.function.name.js";
import { enquireScreen } from './utils/util';
import { mapState, mapMutations } from 'vuex';
import themeUtil from '@/utils/themeUtil';
import { getI18nKey } from '@/utils/routerUtil';
import { getPublicData } from '@/services/common';
function findMenu(menuArr, name) {
  for (var i = 0; i < menuArr.length; i++) {
    var menu = menuArr[i];
    if (menu.name === name) {
      return menu;
    }
    if (menu.children && menu.children.length > 0) {
      var foundMenu = findMenu(menu.children, name);
      if (foundMenu) return foundMenu;
    }
  }
  return null;
}
export default {
  name: 'App',
  data: function data() {
    return {
      locale: {}
    };
  },
  created: function created() {
    var _this = this;
    this.setHtmlTitle();
    this.setLanguage(this.lang);
    enquireScreen(function (isMobile) {
      return _this.setDevice(isMobile);
    });
  },
  mounted: function mounted() {
    console.log('App mounted');
    this.setWeekModeTheme(this.weekMode);
    getPublicData().then(function (response) {
      //动态修改icon,正式开发,需要通过接口请求,返回ico图标地址,替换link.href
      if (response.data.code == 200) {
        localStorage.uploadLimit = response.data.data.uploadLimit;
      }
    });
  },
  watch: {
    weekMode: function weekMode(val) {
      this.setWeekModeTheme(val);
    },
    lang: function lang(val) {
      this.setLanguage(val);
      this.setHtmlTitle();
    },
    $route: function $route() {
      this.setHtmlTitle();
    },
    'theme.mode': function themeMode(val) {
      var closeMessage = this.$message.loading("\u60A8\u9009\u62E9\u4E86\u4E3B\u9898\u6A21\u5F0F ".concat(val, ", \u6B63\u5728\u5207\u6362..."));
      themeUtil.changeThemeColor(this.theme.color, val).then(closeMessage);
    },
    'theme.color': function themeColor(val) {
      var closeMessage = this.$message.loading("\u60A8\u9009\u62E9\u4E86\u4E3B\u9898\u8272 ".concat(val, ", \u6B63\u5728\u5207\u6362..."));
      themeUtil.changeThemeColor(val, this.theme.mode).then(closeMessage);
    },
    'layout': function layout() {
      window.dispatchEvent(new Event('resize'));
    },
    user: function user() {
      /**
       * 如果当前用户不是管理员，就不显示用户管理菜单
       */
      if (this.user && this.menuData) {
        var foundMenu = findMenu(this.menuData, '账号列表');
        console.log('menu', foundMenu);
        if (foundMenu) {
          if (!foundMenu.meta) {
            foundMenu.meta = {};
          }
          if (this.user.adminFlag !== 1) {
            foundMenu.meta.invisible = true; // 不显示账号列表
          } else {
            foundMenu.meta.invisible = false;
          }
        }
      }
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('setting', ['layout', 'theme', 'weekMode', 'lang', 'menuData'])), mapState('account', ['user'])),
  methods: _objectSpread(_objectSpread({}, mapMutations('setting', ['setDevice'])), {}, {
    setWeekModeTheme: function setWeekModeTheme(weekMode) {
      if (weekMode) {
        document.body.classList.add('week-mode');
      } else {
        document.body.classList.remove('week-mode');
      }
    },
    setLanguage: function setLanguage(lang) {
      this.$i18n.locale = lang;
      switch (lang) {
        case 'CN':
          this.locale = require('ant-design-vue/es/locale-provider/zh_CN').default;
          break;
        case 'HK':
          this.locale = require('ant-design-vue/es/locale-provider/zh_TW').default;
          break;
        case 'JP':
          this.locale = require('ant-design-vue/es/locale-provider/ja_JP').default;
          break;
        case 'US':
        default:
          this.locale = require('ant-design-vue/es/locale-provider/en_US').default;
          break;
      }
    },
    setHtmlTitle: function setHtmlTitle() {
      var route = this.$route;
      var key = route.path === '/' ? 'home.name' : getI18nKey(route.matched[route.matched.length - 1].path);
      document.title = process.env.VUE_APP_NAME + ' | ' + this.$t(key);
    },
    popContainer: function popContainer() {
      return document.getElementById("popContainer");
    }
  })
};